module.exports = __webpack_public_path__ + "assets/fa858ce287508aebe8e0b6abeefa8a79.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level1_WinKP35V1_02.mp3
 ** module id = 391
 ** module chunks = 0
 **/